import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Markdown from 'react-markdown'
import axios from "axios";
import { apiRoot, UserContext, SetUserContext } from "..";
import { Spinner } from "react-bootstrap";

const DeleteNewsItemModal = (props) => {
  return (
    <Modal
    show={props.show}
    onHide={props.handleCancel}
    backdrop="static"
    keyboard={false}
    >
    <Modal.Header closeButton>
      <Modal.Title>Odstranit aktualitu</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {props.errorMessage && <div className="alert alert-danger" role="alert">{props.errorMessage}</div>}
      Chcete opravdu odstranit tuto aktualitu?
    </Modal.Body>
    <Modal.Footer>
      {props.proceeding ? <Spinner as="span" animation="border" size="sm" /> : <></>}
      <Button variant="secondary" onClick={props.handleCancel} disable={props.proceeding.toString()}>Zrušit</Button>
      <Button variant="danger" onClick={props.handleProceed} disable={props.proceeding.toString()}>
        <i className="fa fa-trash-o" aria-hidden="true"></i> Odstranit aktualitu
      </Button>
    </Modal.Footer>
    </Modal>
  )
}

const Home = () => {
  const user = useContext(UserContext);
  const setUser = useContext(SetUserContext);
  const queryClient = useQueryClient();

  const fetchNewsQuery = useQuery(['fetchNews'], async () => {
    const {data} = await axios.get(apiRoot + '/news');
    return data;
  }, {
    onError: (err) => {
      console.log('fetchNews error: ' + err) // TODO
    }
  });

  const setNotificationsMutation = useMutation((notifications) => {
    return axios.post(apiRoot  + '/users/' + user.userId + '/notifications', notifications);
  },
  {
    onSuccess: () => {
      setUser(user => ({...user, isNotified: !user.isNotified}));
    },
    onError: (error) => {
      console.log("setNotificationsMutation error: " + error) // TODO
    }
  });

  const handleSetNotificationsClick = (val) => {
    setNotificationsMutation.mutate({notified: val});
  }

  const [newsItemIdForDelete, setNewsItemIdForDelete] = useState(null);

  const deleteNewsItemMutation = useMutation((newsItemId) => {
    return axios.delete(apiRoot  + '/news/' + newsItemId);
  },
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchNews']);
      setNewsItemIdForDelete(null);  
    },
    onError: (error) => {
      console.log("deleteNewsItemMutation error: " + error) // TODO
    }
  });

  const deleteNewsItemProceed = () => {  
    deleteNewsItemMutation.mutate(newsItemIdForDelete);
  };

  const deleteNewsItemCancel = () => {
    setNewsItemIdForDelete(null);
    deleteNewsItemMutation.reset();
  };
  
  return (
    <>
<div>
<span className="align-middle">
<i className="fa fa-user-circle-o fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<div className="d-inline-block align-middle">
<strong>Vítejte na SVJ381</strong> - portálu Společenství vlastníků Hrdličkova 2177, Blatenská 2178, 2179.<br />
{user && <>
Jste přihlášen jako <strong>{user.name} (byt {user.appartmentNo})</strong>{user.isCommittee === true && <> - člen výboru</>}{user.isAdmin === true && <> - administrátor</>}.
{user.isNotified === true ?
(<> Zasílání upozornění na novinky máte <strong className="text-success">zapnuté</strong>.</>) :
(<> Zasílání upozornění na novinky máte <strong className="text-danger">vypnuté</strong>.</>)}
</>}
</div>
</span>
<span className="align-middle">
{user && <>
{user.isNotified === true ?
(<> <button className="btn btn-secondary" disable={setNotificationsMutation.isLoading.toString()} onClick={() => {handleSetNotificationsClick("no")}}>Vypnout zasílání upozornění</button></>) :
(<> <button className="btn btn-success" disable={setNotificationsMutation.isLoading.toString()} onClick={() => {handleSetNotificationsClick("yes")}}>Zapnout zasílání upozornění</button></>)
}
</>}
{setNotificationsMutation.isLoading ? <>&nbsp;<Spinner as="span" animation="border" size="sm" /></> : <></>}
</span>
</div>
{setNotificationsMutation.isError && <div className="alert alert-danger" role="alert">{setNotificationsMutation.error.message}</div>}
<div>&nbsp;</div>

<div>
<span>
<i className="fa fa-exclamation-circle fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Aktuality</h2>
</span>
{user && user.isPowerUser &&
<span> <Link to={"/pridat-aktualitu"} className="btn btn-success align-middle" role="button"><i className="fa fa-plus" aria-hidden="true"></i> Přidat aktualitu</Link></span>
}
</div>
{fetchNewsQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchNewsQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání aktualit.</div>
}
{fetchNewsQuery.data && fetchNewsQuery.data.map(newsItem => (
  <div key={newsItem.id} style={{margin: '10px 0 10px 0', padding: '5px', border: '1px solid #aaaaaa', borderRadius: '5px', backgroundColor: '#eeeeee'}}>
    <div style={{marginBottom: '1em', fontWeight: 'bold', fontSize: '150%'}}>{newsItem.header}</div>
    <div className="text-break"><Markdown>{newsItem.content}</Markdown></div>
    <div style={{fontStyle: 'italic', textAlign: 'right'}}>Vložil: {newsItem.author}, {newsItem.created}</div>
    {user && user.isPowerUser &&
    <div style={{textAlign: 'right'}}><button className="btn btn-danger" onClick={() => {setNewsItemIdForDelete(newsItem.id)}}><i className="fa fa-trash-o" aria-hidden="true"></i> Odstranit aktualitu</button></div>
    }
  </div>
))}
  <DeleteNewsItemModal show={newsItemIdForDelete} proceeding={deleteNewsItemMutation.isLoading}
    handleProceed={deleteNewsItemProceed} handleCancel={deleteNewsItemCancel}
    errorMessage={deleteNewsItemMutation.isError ? deleteNewsItemMutation.error.message : null} />
    </>
  );
};
  
export default Home;